import { render } from "./WordDayPopup.vue?vue&type=template&id=777aec57"
import script from "./WordDayPopup.vue?vue&type=script&lang=js"
export * from "./WordDayPopup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__